import { useRequest } from 'ahooks';
import { useMemo } from 'react';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { getTikTokGrayStatusShops, TikTokGrayStatusShop } from 'services/api/tiktokReview';

const tiktokReviewStoresStatusState = atom<TikTokGrayStatusShop[]>([]);

export const useSetTikTokReviewStoresStatus = () => useSetAtom(tiktokReviewStoresStatusState);

export const useTikTokReviewStoresStatus = () => useAtomValue(tiktokReviewStoresStatusState);

export const useIsTikTokReviewStoreOffline = (storeId: string) => {
  const stores = useTikTokReviewStoresStatus();

  return useMemo(() => {
    const found = stores.find(({ externalStoreId }) => storeId === externalStoreId);
    return found && !found.online;
  }, [storeId, stores]);
};

export const useRefreshTikTokReviewStores = (platform: General.PlatformUpperCase) => {
  const setTikTokReviewStoresStatus = useSetTikTokReviewStoresStatus();
  const { loading, runAsync } = useRequest(() => getTikTokGrayStatusShops(platform), {
    manual: true,
    onSuccess(shopStatus) {
      setTikTokReviewStoresStatus(shopStatus);
    },
  });

  return {
    runAsync,
    loading,
  };
};
